import { useState, useEffect } from 'react';
import { useStore } from './useStore';

export const usePoolCompanies = (poolId) => {
    const stores = useStore();
    const [filteredCompanyList, setFilteredCompanyList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const loadPoolCompanies = async () => {
            if (poolId) {
                setIsLoading(true);
                try {
                    const poolDetail = await stores.poolStore.getPool({ poolId });
                    if (poolDetail) {
                        const companyIds = poolDetail.companies.map(c => c._id);
                        setFilteredCompanyList(companyIds);
                    }
                } catch (error) {
                    console.error('Error loading pool companies:', error);
                    setFilteredCompanyList([]);
                } finally {
                    setIsLoading(false);
                }
            } else {
                setFilteredCompanyList([]);
            }
        };

        loadPoolCompanies();
    }, [poolId, stores.poolStore]);

    const filterCompany = (company) => {
        if (poolId) {
            return filteredCompanyList.includes(company._id);
        }
        return true;
    };

    return {
        filteredCompanyList,
        isLoading,
        filterCompany
    };
};